import { reducer as modalForm } from './modules/modalForm';
import { reducer as schedulers } from './modules/schedulers';
import { reducer as searchHistory } from './modules/searchHistory';
import { reducer as toasts } from './modules/toasts';

export default {
  modalForm,
  schedulers,
  searchHistory,
  toasts,
};
